import type { Layer } from '@geosoft/viewer-sdk';

const HOUR_MS = 60 * 60 * 1000;

function parseIso(value: string | undefined): number | null {
  if (!value) return null;
  const t = Date.parse(value);
  return Number.isFinite(t) ? t : null;
}

export function deriveTimelineWindow(
  catalog: Layer[],
  visibleLayerIds: Set<string>,
  fallbackNow: number = Date.now(),
): { minMs: number; maxMs: number } {
  let minMs = Number.POSITIVE_INFINITY;
  let maxMs = Number.NEGATIVE_INFINITY;

  for (const layer of catalog) {
    if (!visibleLayerIds.has(layer.id)) continue;
    const start = parseIso(layer.temporal?.start);
    const end = parseIso(layer.temporal?.end);
    if (start !== null) minMs = Math.min(minMs, start);
    if (end !== null) maxMs = Math.max(maxMs, end);
  }

  if (!Number.isFinite(minMs) || !Number.isFinite(maxMs) || minMs >= maxMs) {
    return { minMs: fallbackNow - 12 * HOUR_MS, maxMs: fallbackNow + 12 * HOUR_MS };
  }
  return { minMs, maxMs };
}

export function formatTimelineLabel(ms: number): string {
  return new Date(ms).toISOString().replace('T', ' ').replace('.000Z', 'Z');
}
